import { useState } from 'react';
import { styled } from 'styled-components';

import { Box } from '#/components/Box/Box';
import { Body } from '#/components/Text/Body';
import { RichTextHeadline } from '#/components/Text/RichTextHeadline';
import type { CmsApiAccordionBlockData } from '#/modules/cms/api/types/blocks/CmsApiAccordionBlock';
import { colors } from '#/theme/theme';

import { CmsAccordionBlockTitle } from './CmsAccordionBlockTitle';

const AccordionSection = styled.div`
  border-bottom: 1px solid ${colors.elementGrey};
`;

type Props = {
  blockIndex: number;
  data: CmsApiAccordionBlockData;
  fullWidthLayout?: boolean;
};

export function CmsAccordionBlock({
  blockIndex,
  data: { sections, default: defaultState, headline, subtitle },
  fullWidthLayout,
}: Props) {
  const [currentSection, setcurrentSection] = useState(
    defaultState === 'FIRST_ONE_OPENED' ? 0 : null,
  );

  const toggle = (index: number) => {
    setcurrentSection(index === currentSection ? null : index);
  };

  return (
    <div>
      {(headline ?? subtitle) && (
        <Box mb={64} textAlign={fullWidthLayout ? 'center' : 'left'}>
          {headline && <RichTextHeadline>{headline}</RichTextHeadline>}
          {subtitle && (
            <Body
              analyticsData={{
                eventName: 'CMS Block',
                eventProperties: {
                  block_position: blockIndex,
                  block_type: 'Accordion',
                },
              }}
              dangerouslySetInnerHTML={{
                __html: subtitle,
              }}
            />
          )}
        </Box>
      )}

      {sections.map((section, index) => (
        // TODO: Fix this the next time the file is edited.
        // oxlint-disable-next-line react/no-array-index-key
        <AccordionSection key={`${section.title}-${index}`}>
          <Box mt={index === 0 ? '-30px' : 0}>
            <CmsAccordionBlockTitle
              onClick={() => toggle(index)}
              toggled={index === currentSection}
              index={index}
              title={section.title}
            />
          </Box>

          <Box display={index === currentSection ? 'block' : 'none'} pb="30px">
            <Body
              aria-hidden={index !== currentSection}
              id={`accordionSection${index}`}
              analyticsData={{
                eventName: 'CMS Block',
                eventProperties: {
                  block_position: blockIndex,
                  block_type: 'Accordion',
                },
              }}
              dangerouslySetInnerHTML={{
                __html: section.content,
              }}
              m="0"
            />
          </Box>
        </AccordionSection>
      ))}
    </div>
  );
}
